import "core-js/modules/es6.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { FLASH_TIMER, FAST_TIMER } from '~/const/timers';
export default {
  name: 'MdmLayer',
  props: {
    title: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      childTitle: '',
      initialPageYOffset: 0,
      open: false,
      component: null,
      shouldClose: true,
      prevCmp: null,
      payload: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$root.$on('open-layer', function (payload) {
      _this.payload = payload;

      if (_this.component !== null) {
        _this.shouldClose = false;
        _this.prevCmp = _this.component;
      }

      _this.childTitle = payload.context;

      _this.component = function () {
        return _this.getLayer(payload.name);
      };

      setTimeout(function () {
        _this.handleLayer(payload.state);
      }, FLASH_TIMER);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('open-layer');
  },
  methods: {
    handleLayer: function handleLayer(state) {
      this.disableWindowScroll();
      this.bindEscKey();
      this.open = state;
    },
    closeLayer: function closeLayer() {
      var _this2 = this;

      if (this.shouldClose === false) {
        this.component = this.prevCmp;
        this.prevCmp = null;
        this.shouldClose = true;
      } else {
        this.open = false;
        this.enableWindowScroll();
        this.unbindEscKey();
        setTimeout(function () {
          _this2.component = null;
        }, FAST_TIMER);
      }
    },
    bindEscKey: function bindEscKey() {
      document.addEventListener('keyup', this.handleKeyUp, {
        passive: true
      });
    },
    unbindEscKey: function unbindEscKey() {
      document.removeEventListener('keyup', this.handleKeyUp);
    },
    handleKeyUp: function handleKeyUp(e) {
      if (e.keyCode === 27) {
        this.closeLayer();
        return false;
      }

      return false;
    },
    getLayer: function getLayer(slug) {
      this.component = function () {
        return import("./Layers/".concat(slug));
      };
    }
  }
};